import React from 'react'

import Base from '../_Base'

const PerkStore = (props) => (
  <Base width="40" height="40" viewBox="0 0 40 40" {...props}>
    <path
      d="M25.2814075,2.30186158 C26.6458745,3.65903644 27.4537648,5.21319106 27.8144106,7.00031093 L36,7 L36,40 L4,40 L4,7 L12.1771255,7.00012684 C12.6677049,4.48923466 13.9818851,2.53789874 16.1001181,1.20649377 C19.3859017,-0.858769436 22.8382658,-0.128223123 25.2814075,2.30186158 Z M34,9 L28,9 L28,15 L26,15 L26.003,9 L14,9 L14,15 L12,15 L12.003,9 L6,9 L6,38 L34,38 L34,9 Z M17.1661834,2.8947973 C15.6232469,3.86460247 14.6442437,5.23063808 14.2148867,6.99957188 L25.7703269,6.99982774 C25.4553847,5.77132347 24.8462454,4.68665009 23.8693591,3.71498458 C22.0375418,1.8929571 19.5855728,1.37410195 17.1661834,2.8947973 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default PerkStore
